export const isImageFile = src => src.endsWith('jpg') || src.endsWith('jpeg') || src.endsWith('png');
export const convertImagePathToWebp = src => src.replace(/(.jpg|.jpeg|.png)/, '.webp');
export const getMockImage = (width, height) => `https://picsum.photos/${width}/${height}`;
export const getImagePath = subDir => fileName => {
  let imgPath = '/image/'
  if(subDir){
    imgPath += `${subDir}/`;
  }
  return `${imgPath}${fileName}`;
};